import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBody, TextHeadline1 } from '../common/Text'
import { vw } from '../../styles/theme'
import useLocale from '../../hooks/useLocale'

export type TopActivitieProps = BoxProps & {}

const TopActivitie: React.FC<TopActivitieProps> = ({ ...others }) => {
  const { isJa } = useLocale()
  return (
    <>
      {isJa && (
        <Box pt={[vw(150), '200px']} {...others}>
          <Box w={['contentSP', '660px']} m="0 auto" textAlign={['center', 'left']}>
            <Box mb={[vw(60), '60px']}>
              <TextHeadline1 as="h2" localizeKey="top__activitie__title" lineHeight="1" />
            </Box>
            <Box>
              <TextBody localizeKey="top__activitie__content_body_1" />
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}

export default TopActivitie
